import { render } from "./ReferentDatatable.vue?vue&type=template&id=13f295cc"
import script from "./ReferentDatatable.vue?vue&type=script&lang=js"
export * from "./ReferentDatatable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/referents/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__